
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    title: String,
  },
})
export default class SectionTitle extends Vue {
  title!: string;
}
